import { Spacing } from '@billy/design-system'
import { css } from '@emotion/core'

export const getTableCellStyles = () => {
  return css`
    min-width: 160px;
    padding-inline: ${Spacing.S24};
    padding-block: ${Spacing.S16};
    text-align: right;
    align-content: center;

    :first-of-type {
      text-align: left;
      padding-left: ${Spacing.S40};
      min-width: 320px;
      max-width: 320px;
    }
  `
}
